module.exports = __webpack_public_path__ + "img/cruisers.5859fb8a.svg";